import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';

const PLAN_LABELS = {
  free: 'Free',
  pro: 'Pro',
  team: 'Team',
  enterprise: 'Enterprise',
};

/**
 * Reusable upgrade prompt banner shown when users hit tier limits.
 *
 * Usage:
 *   <UpgradePrompt feature="voices" currentLimit={3} planNeeded="pro"
 *     message="Upgrade to Pro for up to 7 voices" />
 */
export default function UpgradePrompt({ feature, currentLimit, planNeeded = 'pro', message }) {
  const navigate = useNavigate();
  const planLabel = PLAN_LABELS[planNeeded] || planNeeded;

  return (
    <div
      className="w-full p-3 bg-gradient-to-r from-[#FF4D00]/10 to-[#FF4D00]/5 border border-[#FF4D00]/30 flex flex-col sm:flex-row sm:items-center gap-3"
      data-testid={`upgrade-prompt-${feature}`}
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Zap className="w-4 h-4 text-[#FF4D00] shrink-0" />
        <div className="min-w-0">
          <p className="text-sm text-[#F5F5F5] truncate">
            {message || `Upgrade to ${planLabel} to unlock more`}
          </p>
          {currentLimit != null && (
            <p className="text-[10px] font-mono text-[#A0A0A0] mt-0.5">
              Current limit: {currentLimit} ({planLabel} plan)
            </p>
          )}
        </div>
      </div>
      <button
        onClick={() => navigate('/pricing')}
        className="px-4 py-2 min-h-[44px] bg-[#FF4D00] text-black text-xs font-semibold font-mono shrink-0 hover:bg-[#FF4D00]/90 transition-colors flex items-center gap-1.5"
        data-testid="upgrade-cta"
      >
        <Zap className="w-3 h-3" />
        Upgrade to {planLabel}
      </button>
    </div>
  );
}
